import { AutogenLayoutOpenItemSelection } from "./autogen/AutogenLayoutOpenItemSelection";

export class OpenItemSelection extends AutogenLayoutOpenItemSelection {
}
